exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer-text {\n  text-align: center;\n  /* color: #868e96; */\n  font-weight: bold;\n  font-family: \"Google Sans Regular\";\n}\n\n.footer-div {\n  margin-top: 2rem;\n}\n", ""]);

